import { FC, useState } from "react"
import { usePartCategories, usePartChemicals } from "@ncs/ncs-api"
import { ShopBarNavSubmenu } from "./sub-menu/ShopBarNavSubmenu"
import {
	AnimatedEntrance,
	encodeUrlState,
	EventTracker,
	Icon,
	Link,
	TrackingEvent,
	Flag,
	useIsFeatureFlagOn,
} from "@ncs/web-legos"
import { PartSearchResultsUrlState } from "~/views/shop/part-search-results"
import { useAnalytics } from "~/hooks/useAnalytics"
import { navListStyle, submenuContainerStyle } from "./styles"

export const ShopBarNav: FC = () => {
	const [categories] = usePartCategories()
	const [chemicals] = usePartChemicals()
	// eslint-disable-next-line
	const [showCategoriesSubmenu, setShowCategoriesSubmenu] = useState(false)
	const [showChemicalsSubmenu, setShowChemicalsSubmenu] = useState(false)
	const { trackEvent } = useAnalytics()
	const hideTrending = useIsFeatureFlagOn(Flag.VITE_FLAG_HIDE_TRENDING)

	const chemicalsSubmenuHandler = () => {
		setShowChemicalsSubmenu(true)
		trackEvent(TrackingEvent.CHEMISTRY_CATEGORY)
	}

	const partsSubmenuHandler = () => {
		setShowCategoriesSubmenu(true)
		trackEvent(TrackingEvent.PARTS_CATEGORY)
	}

	return (
		<ul css={navListStyle}>
			<li
				className="has-children"
				onMouseEnter={chemicalsSubmenuHandler}
				onMouseLeave={() => setShowChemicalsSubmenu(false)}
			>
				<span>
					<span>Chemicals</span>
					<span style={{ marginLeft: "5px" }}>
						<Icon icon="chevron-down" />
					</span>
				</span>
				<AnimatedEntrance
					show={showChemicalsSubmenu}
					css={submenuContainerStyle}
					duration={400}
					delay={400}
				>
					<ShopBarNavSubmenu
						columnCount={2}
						items={(chemicals ?? []).map((chemical) => ({
							label: chemical.name ?? chemical.id,
							to: `/shop/search${encodeUrlState<PartSearchResultsUrlState>({ categories: [chemical.id], page: 1 })}`,
						}))}
					/>
				</AnimatedEntrance>
			</li>
			<li
				className="has-children"
				onMouseEnter={partsSubmenuHandler}
				onMouseLeave={() => setShowCategoriesSubmenu(false)}
			>
				<span>
					<span>Parts</span>
					<span style={{ marginLeft: "5px" }}>
						<Icon icon="chevron-down" />
					</span>
				</span>
				<AnimatedEntrance
					show={showCategoriesSubmenu}
					css={submenuContainerStyle}
					duration={400}
					delay={400}
				>
					<ShopBarNavSubmenu
						items={(categories ?? []).map((category) => ({
							label: category.name ?? category.id,
							to: `/shop/search${encodeUrlState<PartSearchResultsUrlState>({ categories: [category.id], page: 1 })}`,
						}))}
					/>
				</AnimatedEntrance>
			</li>
			{!hideTrending && (
				<li>
					<EventTracker event={TrackingEvent.TRENDING} trackEvent={trackEvent}>
						<Link
							to={`/shop/search${encodeUrlState<PartSearchResultsUrlState>({ featured: true, page: 1 })}`}
						>
							<span>Trending</span>
						</Link>
					</EventTracker>
				</li>
			)}
			<li>
				<EventTracker event={TrackingEvent.CLEARANCE_NAV_BAR} trackEvent={trackEvent}>
					<Link
						to={`/shop/search${encodeUrlState<PartSearchResultsUrlState>({ clearance: true, page: 1 })}`}
					>
						<span>Clearance</span>
					</Link>
				</EventTracker>
			</li>
		</ul>
	)
}
